module.exports = __webpack_public_path__ + "img/residentList4.cf0b08db.png";